import React from 'react';
import LanguageSelector from '../LanguageSelector';

import CountdownElement from '../CountdownElement';

import Article from '../../styled-components/Article';
import Hand from '../../styled-components/Hand';
import Logo from '../../styled-components/Logo';
import CenteredWrapper from '../../styled-components/CenteredWrapper';
import CTAWrapper from '../../styled-components/CTAWrapper';
import H2 from '../../styled-components/H2';
import Apply from '../../styled-components/Apply';

import introBg from '../../img/bg-intro.jpg';
import introBgMobile from '../../img/mobile-bg.jpg';
import camera from '../../img/camera.svg';
import camera2 from '../../img/camera2.svg';
import phone from '../../img/phone.svg';
import phone2 from '../../img/phone2.svg';
import mic from '../../img/mic.svg';
import curved from '../../img/curved.svg';
import gamer from '../../img/gamer.svg';
import curved2 from '../../img/curved2.svg';
import logo from '../../img/logo.svg';
import poweredByBBTV from '../../img/powered-by-bbtv.svg';

const Intro = ({intro, googleLogin, apply, applyLabelLink, language}) => (
  <Article bg={introBg} bgMobile={introBgMobile}>
    <Hand src={gamer} bottom="-20px" left="50%" hCenter hideOnMobile style={{zIndex: 4}} />
    <Hand src={gamer} bottom="-30px" left="50%" hCenter onlyOnMobile style={{zIndex: 4, width: '35vh'}} />
    <Hand src={camera} top="0" left="0" noMaxWidth hideOnMobile />
    <Hand src={camera2} top="0" left="0" onlyOnMobile />
    <Hand src={phone} top="0" right="20%" hideOnMobile />
    <Hand src={phone2} top="8%" right="0" onlyOnMobile />
    <Hand src={mic} top="50%" left="-100px" vCenter hideOnMobile />
    <Hand src={poweredByBBTV} bottom="20px" left="50%" hCenter />

    <CenteredWrapper centeredText column style={{alignItems: 'center', zIndex: '4'}}>
      <LanguageSelector
        items={language.allLanguages}
        language={language.selected}
        marginBottom
      />
      <h1 style={{verticalAlign: 'middle'}}><Logo src={logo} large /></h1>
      <H2 style={{paddingTop: 0}}>{intro}</H2>
    </CenteredWrapper>

    <CTAWrapper>
      <Hand src={curved} top="-260px" right="0" hideOnMobile />
      <Hand src={curved2} top="-90px" right="0" onlyOnMobile />
      <CountdownElement googleLogin={googleLogin} />
      <Apply>{apply.label} <a href={apply.url} target="_blank">{apply.labelLink}</a></Apply>
    </CTAWrapper>
  </Article>
);

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Intro/index.js